import TopNewsModule from 'app/components/topNewsModule/TopNewsModule';
import { AdSlot } from 'app/components/ads/AdSlot';
import FuPaApiError from 'app/models/error/FuPaApiError';
import FirstCompetitionModule from 'app/components/competitionModule/FirstCompetitionModule';
import MediaModule from 'app/components/mediaModule/MediaModule';
import CompetitionModuleInfiniteList from 'app/components/competitionModule/CompetitionModuleInfiniteList';
import React from 'react';
import { useQueryCompetitionModules } from 'app/queries/useQueryComptitionModules';
import { useParams } from 'react-router';
import TransferModule from 'app/components/transferModule/TransferModule';
import { CompetitionModuleList } from 'app/components/competitionModule/common/CompetitionModuleList';
import SecondAndThirdCompetitionModule from 'app/components/competitionModule/SecondAndThirdCompetitionModule';
export default function MainPageContent(_ref) {
  let {
    name,
    initialState
  } = _ref;
  const {
    districtSlug
  } = useParams();
  const {
    infiniteResult,
    infiniteCompetitionModules
  } = useQueryCompetitionModules(districtSlug, initialState.competitions);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopNewsModule, {
    initialData: initialState.topNews,
    "data-sentry-element": "TopNewsModule",
    "data-sentry-source-file": "MainPageContent.tsx"
  }), /*#__PURE__*/React.createElement(AdSlot, {
    adLayout: "mobile",
    adUnit: "Content_1",
    limitedDim: false,
    noMargin: true,
    "data-sentry-element": "AdSlot",
    "data-sentry-source-file": "MainPageContent.tsx"
  }), /*#__PURE__*/React.createElement(CompetitionModuleList, {
    "data-sentry-element": "CompetitionModuleList",
    "data-sentry-source-file": "MainPageContent.tsx"
  }, /*#__PURE__*/React.createElement(FirstCompetitionModule, {
    data: infiniteCompetitionModules.getFirstCompetitionModule(),
    infiniteResult: infiniteResult,
    "data-sentry-element": "FirstCompetitionModule",
    "data-sentry-source-file": "MainPageContent.tsx"
  }), /*#__PURE__*/React.createElement(AdSlot, {
    adLayout: "desktop",
    adUnit: "Native_1",
    limitedDim: false,
    noMargin: true,
    "data-sentry-element": "AdSlot",
    "data-sentry-source-file": "MainPageContent.tsx"
  })), /*#__PURE__*/React.createElement(MediaModule, {
    initialData: initialState.media,
    districtName: name,
    "data-sentry-element": "MediaModule",
    "data-sentry-source-file": "MainPageContent.tsx"
  }), /*#__PURE__*/React.createElement(AdSlot, {
    adLayout: "mobile",
    adUnit: "Native_1",
    limitedDim: false,
    noMargin: true,
    "data-sentry-element": "AdSlot",
    "data-sentry-source-file": "MainPageContent.tsx"
  }), /*#__PURE__*/React.createElement(AdSlot, {
    adLayout: "desktop",
    adUnit: "Superbanner_2",
    limitedDim: false,
    noMargin: true,
    "data-sentry-element": "AdSlot",
    "data-sentry-source-file": "MainPageContent.tsx"
  }), /*#__PURE__*/React.createElement(SecondAndThirdCompetitionModule, {
    data: infiniteCompetitionModules,
    "data-sentry-element": "SecondAndThirdCompetitionModule",
    "data-sentry-source-file": "MainPageContent.tsx"
  }), /*#__PURE__*/React.createElement(TransferModule, {
    initialData: initialState.transfers,
    "data-sentry-element": "TransferModule",
    "data-sentry-source-file": "MainPageContent.tsx"
  }), infiniteResult instanceof FuPaApiError ? null : /*#__PURE__*/React.createElement(CompetitionModuleInfiniteList, {
    infiniteResponse: infiniteResult,
    infiniteCompetitionModules: infiniteCompetitionModules
  }));
}